new Swiper('.our-product-slider', {
    pagination: {
        el: ".swiper-pagination",
        type: "progressbar",
      },
     breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        580: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
     },
});